module.exports = __webpack_public_path__ + "static/template_options_month_span_multiple_pages-9a844f9a213393e3d213d0a0b50723c2.png";